import {
  IAvailabilityDataDTO,
  IAvailabilityDataRequestDTO,
  IUpsertOverrideDataRequestDTO,
  IAvailabilityPreferenceDTO,
  IUpsertAvailabilityPreferencesRequestDTO,
  IUpsertAvailabilityCycleRequestDTO,
  IESSAvailabilityCycleDTO,
} from 'src/api/dtos';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import api from 'src/api/rtk/rtk-api';
import { IListQueryResult, IQueryResult } from 'src/api/types';

export default class AvailabilityRepository extends ESSRepository {
  private static readonly baseRoute = '/availabilities';
  private static readonly apiURL = AvailabilityRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      getAvailability: build.query<IAvailabilityDataDTO, IAvailabilityDataRequestDTO>({
        query: (params) => {
          return { url: this.apiURL, method: 'get', params };
        },
        providesTags: [{ type: 'Availability', id: 'Availability' }],
      }),
      upsertAvailability: build.mutation<IAvailabilityDataDTO, IUpsertOverrideDataRequestDTO>({
        query: (data) => {
          return { url: this.apiURL, method: 'patch', data };
        },
        invalidatesTags: (_, error) => (error ? [] : [{ type: 'Availability', id: 'Availability' }, 'Calendar']),
      }),
      getCurrentCycle: build.query<IESSAvailabilityCycleDTO, void>({
        query: () => {
          return { url: `${this.apiURL}/currentcycle`, method: 'get' };
        },
        transformResponse: (response: IQueryResult<IESSAvailabilityCycleDTO>) => response.item,
        providesTags: [{ type: 'Availability', id: 'Current Cycle' }],
      }),
      getFutureCycles: build.query<IESSAvailabilityCycleDTO[], void>({
        query: () => {
          return { url: `${this.apiURL}/futurecycles`, method: 'get' };
        },
        transformResponse: (response: IListQueryResult<IESSAvailabilityCycleDTO>) => response.items,
        providesTags: [{ type: 'Availability', id: 'Future Cycles' }],
      }),
      updatePreferences: build.mutation<IAvailabilityPreferenceDTO[], IUpsertAvailabilityPreferencesRequestDTO>({
        query: (data) => {
          return { url: `${this.apiURL}/preferences`, method: 'patch', data };
        },
        transformResponse: (response: IListQueryResult<IAvailabilityPreferenceDTO>) => response.items,
        invalidatesTags: (_, error) => (error ? [] : ['Availability', 'Calendar']),
      }),
      updateCycle: build.mutation<IESSAvailabilityCycleDTO, IUpsertAvailabilityCycleRequestDTO>({
        query: (data) => {
          return { url: `${this.apiURL}/cycle`, method: 'patch', data };
        },
        transformResponse: (response: IQueryResult<IESSAvailabilityCycleDTO>) => response.item,
        invalidatesTags: (_, error) => (error ? [] : [{ type: 'Availability', id: 'Future Cycles' }, 'Calendar']),
      }),
    }),
  });
}
